import React, { useState } from "react";
import { Link } from "react-router-dom";

import Choices from "./Choices";
import Footer from "./Footer";
import "./styles/App.css";

export default function Question(props) {
  const [isChecked, setIsChecked] = useState([]);

  function calculateResultPath() {
    if (props.result >= 0 && props.result <= 3) {
      return "result1";
    } else if (props.result > 3 && props.result <= 6) {
      return "result2";
    } else if (props.result > 6 && props.result <= 9) {
      return "result3";
    } else if (props.result > 9 && props.result <= 12) {
      return "result4";
    }
  }

  return (
    <>
      <div className="content-container">
        <img
          src="/images/Horizontal-logo-Wmargin.png"
          className="logo"
          alt="company logo"
        />
        <h1>{props.question}</h1>
        <p className="page-subtitle">{props.subtitle}</p>
        <Choices
          data={props.answers}
          isChecked={isChecked}
          setIsChecked={setIsChecked}
          result={props.result}
          setResult={props.setResult}
        />
      </div>
      <div className="pagination-btn-wrapper">
        <div className="pagination">
          <Link to="/1" style={{ textDecoration: "none" }}>
            <div
              className={`${
                props.active === 1 ? "active" : props.active > 1 ? "past" : ""
              } number`}
            >
              <p>1</p>
            </div>
          </Link>
          <Link to="/2" style={{ textDecoration: "none" }}>
            <div
              className={`${
                props.active === 2 ? "active" : props.active > 2 ? "past" : ""
              } number`}
            >
              <p>2</p>
            </div>
          </Link>
          <Link to="/3" style={{ textDecoration: "none" }}>
            <div
              className={`${
                props.active === 3 ? "active" : props.active > 3 ? "past" : ""
              } number`}
            >
              <p>3</p>
            </div>
          </Link>

          <div className="pagination-icon-bg">
            <img src="/images/pages-icon.png" alt="icon" />
          </div>
        </div>
        <Link
          style={{ textDecoration: "none" }}
          to={`/${
            props.active === 3 ? calculateResultPath() : props.active + 1
          }`}
        >
          <button disabled={isChecked.length === 0 ? true : false}>
            Continue <img src="/images/arrow.png" alt="arrow-icon" />
          </button>
        </Link>
      </div>
      <Footer />
    </>
  );
}
